function formatMaintenanceKmAndM(km: number, m: number): string {
    const meters = Math.round(m);
    const metersStr = Math.abs(meters).toFixed(0).padStart(3, '0');

    if (meters > 0) return `${km}+${metersStr}`;
    if (meters < 0) return `${km}-${metersStr}`;
    return `${km}+000`;
}


export function getDataArrayWithMaintenancePosition(data: any[]): any[] {
    if (!Array.isArray(data)) return [];

    return data.map((item) => {
        const {
            MaintenancePosition,
            MaintenancePositionKm,
            MaintenancePositionM
        } = item;

        // Если уже есть поле, возвращаем как есть
        if (MaintenancePosition) {
            return { ...item, MaintenancePosition };
        }

        // Если можно собрать позицию из Км и М
        if (MaintenancePositionKm != null && MaintenancePositionM != null) {
            return { ...item, MaintenancePosition: formatMaintenanceKmAndM(MaintenancePositionKm, MaintenancePositionM) };
        }

        // Если ничего не подходит — ставим прочерк
        return { ...item, MaintenancePosition: undefined };
    });
}


export function getDataArrayWithMaintenanceEnding(data: any[]): any[] {
    if (!Array.isArray(data)) return [];

    return data.map((item) => {
        const {
            MaintenanceEnding,
            MaintenanceEndingKm,
            MaintenanceEndingM
        } = item;

        if (MaintenanceEnding) {
            return { ...item, MaintenanceEnding };
        }

        if (MaintenanceEndingKm != null && MaintenanceEndingM != null) {
            return { ...item, MaintenanceEnding: formatMaintenanceKmAndM(MaintenanceEndingKm, MaintenanceEndingM) };
        }

        return { ...item, MaintenanceEnding: undefined };
    });
}